<template>
    <div class="style-list">
        <div class="style-item" v-for="(styleClass,idx) in styles" :key="idx" @click="selectStyle(styleClass._id)">
            <div class="btn" :style="jCss(styleClass.style.normal)">{{styleClass.name}}</div>
        </div>
    </div>
</template>

<script>

    import jCss from "../../modules/jCSS.js";

    export default {
        name: "style-list",
        props:{
            styles:Array
        },
        computed: {},
        methods: {
            jCss,
            selectStyle(styleId){
                //this.$emit('change', styleId);
                this.$emit('input', styleId);
            }
        }
    }
</script>

<style scoped>
    .style-list{
        transform: scale(0.5) translate(-50%,-50%);
        width: 200%;
    }
    .style-item{
        margin:2px;
        border:1px solid lightgrey;
        border-radius:2px;
        padding:2px;
        display: inline-block;
    }
</style>